import React, { useEffect, useState } from 'react';
interface PriceDisplayProps {
  amount: number;
  className?: string;
}
export function PriceDisplay({
  amount,
  className = ''
}: PriceDisplayProps) {
  const [formattedPrice, setFormattedPrice] = useState(`$${amount.toLocaleString('es-AR')}`);
  useEffect(() => {
    try {
      const locale = navigator.language || 'es-AR';
      let currency = 'ARS';
      if (locale.startsWith('en-US')) currency = 'USD';else if (locale.startsWith('en-GB')) currency = 'GBP';else if (locale.startsWith('es-ES') || locale.startsWith('fr') || locale.startsWith('de') || locale.startsWith('it')) currency = 'EUR';else if (locale.startsWith('es-MX')) currency = 'MXN';else if (locale.startsWith('es-CO')) currency = 'COP';else if (locale.startsWith('es-CL')) currency = 'CLP';
      const formatter = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      });
      setFormattedPrice(formatter.format(amount));
    } catch (e) {
      setFormattedPrice(`$${amount.toLocaleString('es-AR')}`);
    }
  }, [amount]);
  return <span className={className} data-id="element-146">{formattedPrice}</span>;
}